import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { adminPage } from "./guards";

const AdminDashboard = lazy(() =>
  import("@/pages/admin/AdminDashboard").then((m) => ({
    default: m.AdminDashboard,
  })),
);
const AdminCentrals = lazy(() =>
  import("@/pages/admin/AdminCentrals").then((m) => ({
    default: m.AdminCentrals,
  })),
);
const AdminDoctors = lazy(() =>
  import("@/pages/admin/AdminDoctors").then((m) => ({
    default: m.AdminDoctors,
  })),
);
const AdminReviewers = lazy(() =>
  import("@/pages/admin/AdminReviewers").then((m) => ({
    default: m.AdminReviewers,
  })),
);
const AdminSessions = lazy(() =>
  import("@/pages/admin/AdminSessions").then((m) => ({
    default: m.AdminSessions,
  })),
);
const AdminDoctorDetail = lazy(() =>
  import("@/pages/admin/AdminDoctorDetail").then((m) => ({
    default: m.AdminDoctorDetail,
  })),
);
const AdminReviewerDetail = lazy(() =>
  import("@/pages/admin/AdminReviewerDetail").then((m) => ({
    default: m.AdminReviewerDetail,
  })),
);
const AdminSessionDetail = lazy(() =>
  import("@/pages/admin/AdminSessionDetail").then((m) => ({
    default: m.AdminSessionDetail,
  })),
);
const AdminCentralDetail = lazy(() =>
  import("@/pages/admin/AdminCentralDetail").then((m) => ({
    default: m.AdminCentralDetail,
  })),
);
const AdminCentralCreate = lazy(() =>
  import("@/pages/admin/AdminCentralCreate").then((m) => ({
    default: m.AdminCentralCreate,
  })),
);
const AdminCentralEdit = lazy(() =>
  import("@/pages/admin/AdminCentralEdit").then((m) => ({
    default: m.AdminCentralEdit,
  })),
);
const AdminModerators = lazy(() =>
  import("@/pages/admin/AdminModerators").then((m) => ({
    default: m.AdminModerators,
  })),
);
const AdminSubscriptionRequests = lazy(() =>
  import("@/pages/admin/AdminSubscriptionRequests").then((m) => ({
    default: m.AdminSubscriptionRequests,
  })),
);
const AdminPackages = lazy(() =>
  import("@/pages/admin/AdminPackages").then((m) => ({
    default: m.AdminPackages,
  })),
);
const AdminZonePricing = lazy(() =>
  import("@/pages/admin/AdminZonePricing").then((m) => ({
    default: m.AdminZonePricing,
  })),
);
const AdminZonePricingPreset = lazy(() =>
  import("@/pages/admin/AdminZonePricingPreset").then((m) => ({
    default: m.AdminZonePricingPreset,
  })),
);
const AdminPromoCodes = lazy(() =>
  import("@/pages/admin/AdminPromoCodes").then((m) => ({
    default: m.AdminPromoCodes,
  })),
);
const AdminSubscriptions = lazy(() =>
  import("@/pages/admin/AdminSubscriptions").then((m) => ({
    default: m.AdminSubscriptions,
  })),
);
const AdminCentralSubscriptions = lazy(() =>
  import("@/pages/admin/AdminCentralSubscriptions").then((m) => ({
    default: m.AdminCentralSubscriptions,
  })),
);
const AdminSpecFormControls = lazy(() =>
  import("@/pages/admin/AdminSpecFormControls").then((m) => ({
    default: m.AdminSpecFormControls,
  })),
);
const AdminPendingFieldChanges = lazy(() =>
  import("@/pages/admin/AdminPendingFieldChanges").then((m) => ({
    default: m.AdminPendingFieldChanges,
  })),
);
const AdminAudit = lazy(() =>
  import("@/pages/admin/AdminAudit").then((m) => ({ default: m.AdminAudit })),
);
const AdminContractRegeneration = lazy(() =>
  import("@/pages/admin/AdminContractRegeneration").then((m) => ({
    default: m.AdminContractRegeneration,
  })),
);
const AdminRoles = lazy(() =>
  import("@/pages/admin/AdminRoles").then((m) => ({ default: m.AdminRoles })),
);
const AdminWitnesses = lazy(() =>
  import("@/pages/admin/AdminWitnesses").then((m) => ({
    default: m.AdminWitnesses,
  })),
);
const AdminNotifications = lazy(() =>
  import("@/pages/admin/AdminNotifications").then((m) => ({
    default: m.AdminNotifications,
  })),
);
const AdminContacts = lazy(() =>
  import("@/pages/admin/AdminContacts").then((m) => ({
    default: m.AdminContacts,
  })),
);
const AdminFaqs = lazy(() =>
  import("@/pages/admin/AdminFaqs").then((m) => ({ default: m.AdminFaqs })),
);
const AdminPages = lazy(() =>
  import("@/pages/admin/AdminPages").then((m) => ({ default: m.AdminPages })),
);
const AdminCountries = lazy(() =>
  import("@/pages/admin/AdminCountries").then((m) => ({
    default: m.AdminCountries,
  })),
);
const AdminCountryDetail = lazy(() =>
  import("@/pages/admin/AdminCountryDetail").then((m) => ({
    default: m.AdminCountryDetail,
  })),
);
const AdminSettings = lazy(() =>
  import("@/pages/admin/AdminSettings").then((m) => ({
    default: m.AdminSettings,
  })),
);
const AdminReports = lazy(() =>
  import("@/pages/admin/reports/AdminReports").then((m) => ({
    default: m.AdminReports,
  })),
);
const AdminReportDetail = lazy(() =>
  import("@/pages/admin/reports/AdminReportDetail").then((m) => ({
    default: m.AdminReportDetail,
  })),
);
const AdminReportSchedules = lazy(() =>
  import("@/pages/admin/reports/AdminReportSchedules").then((m) => ({
    default: m.AdminReportSchedules,
  })),
);
const AdminDoctorCompleteness = lazy(() =>
  import("@/pages/admin/AdminDoctorCompleteness").then((m) => ({
    default: m.AdminDoctorCompleteness,
  })),
);
const AdminExports = lazy(() =>
  import("@/pages/admin/AdminExports").then((m) => ({
    default: m.AdminExports,
  })),
);
const AdminSmsMessages = lazy(() =>
  import("@/pages/admin/AdminSmsMessages").then((m) => ({
    default: m.AdminSmsMessages,
  })),
);
// Manual one-off SMS composer — routed but intentionally absent from the sidebar.
const AdminSendSms = lazy(() =>
  import("@/pages/admin/AdminSendSms").then((m) => ({
    default: m.AdminSendSms,
  })),
);
const AdminDoctorRanking = lazy(() =>
  import("@/pages/admin/AdminDoctorRanking").then((m) => ({
    default: m.AdminDoctorRanking,
  })),
);

const AdminWhatsAppMessages = lazy(() => import("@/pages/admin/AdminWhatsAppMessages").then(m => ({ default: m.AdminWhatsAppMessages })));

export const adminRoutes: RouteObject[] = [
  { path: "admin", element: adminPage(<AdminDashboard />) },
  { path: "admin/centrals", element: adminPage(<AdminCentrals />) },
  { path: "admin/centrals/create", element: adminPage(<AdminCentralCreate />) },
  { path: "admin/doctors", element: adminPage(<AdminDoctors />) },
  {
    path: "admin/doctors/completeness",
    element: adminPage(<AdminDoctorCompleteness />),
  },
  { path: "admin/reviewers", element: adminPage(<AdminReviewers />) },
  { path: "admin/sessions", element: adminPage(<AdminSessions />) },
  { path: "admin/centrals/:id/edit", element: adminPage(<AdminCentralEdit />) },
  { path: "admin/centrals/:id", element: adminPage(<AdminCentralDetail />) },
  { path: "admin/doctors/:id", element: adminPage(<AdminDoctorDetail />) },
  {
    path: "admin/doctors/:id/ranking",
    element: adminPage(<AdminDoctorRanking />),
  },
  { path: "admin/reviewers/:id", element: adminPage(<AdminReviewerDetail />) },
  { path: "admin/sessions/:id", element: adminPage(<AdminSessionDetail />) },
  { path: "admin/moderators", element: adminPage(<AdminModerators />) },
  { path: "admin/roles", element: adminPage(<AdminRoles />) },
  {
    path: "admin/subscription-requests",
    element: adminPage(<AdminSubscriptionRequests />),
  },
  { path: "admin/packages", element: adminPage(<AdminPackages />) },
  { path: "admin/zone-pricing", element: adminPage(<AdminZonePricing />) },
  { path: "admin/zone-pricing/preset", element: adminPage(<AdminZonePricingPreset />) },
  { path: "admin/promo-codes", element: adminPage(<AdminPromoCodes />) },
  { path: "admin/subscriptions", element: adminPage(<AdminSubscriptions />) },
  {
    path: "admin/subscriptions/central/:centralId",
    element: adminPage(<AdminCentralSubscriptions />),
  },
  {
    path: "admin/specializations",
    element: adminPage(<AdminSpecFormControls />),
  },
  {
    path: "admin/pending-field-changes",
    element: adminPage(<AdminPendingFieldChanges />),
  },
  { path: "admin/audit", element: adminPage(<AdminAudit />) },
  {
    path: "admin/contract-regeneration",
    element: adminPage(<AdminContractRegeneration />),
  },
  { path: "admin/witnesses", element: adminPage(<AdminWitnesses />) },
  { path: "admin/notifications", element: adminPage(<AdminNotifications />) },
  { path: "admin/contacts", element: adminPage(<AdminContacts />) },
  { path: "admin/faqs", element: adminPage(<AdminFaqs />) },
  { path: "admin/pages", element: adminPage(<AdminPages />) },
  { path: "admin/countries", element: adminPage(<AdminCountries />) },
  { path: "admin/countries/:id", element: adminPage(<AdminCountryDetail />) },
  { path: "admin/settings", element: adminPage(<AdminSettings />) },
  { path: "admin/reports", element: adminPage(<AdminReports />) },
  {
    path: "admin/reports/schedules",
    element: adminPage(<AdminReportSchedules />),
  },
  { path: "admin/reports/:type", element: adminPage(<AdminReportDetail />) },
  { path: "admin/exports", element: adminPage(<AdminExports />) },
  { path: "admin/whatsapp-messages", element: adminPage(<AdminWhatsAppMessages />) },
  { path: "admin/sms-messages", element: adminPage(<AdminSmsMessages />) },
  { path: "admin/send-sms", element: adminPage(<AdminSendSms />) },
  { path: "admin/ranking", element: adminPage(<AdminDoctorRanking />) },
  { path: "admin/ranking/:id", element: adminPage(<AdminDoctorRanking />) },
];
